import {
  useLocation,
} from 'react-router';

import * as S from '../styled';
import ItemIcon from '../ItemIcon';

interface Props {
  to: string,
  name: string
  icon?: string,
  level: number,
  badge?: string
  isOpen: boolean
  isFolder?: boolean
  requiresPremium?: boolean
  onClick?: { (e: any): void }
  hasChild: boolean
  activePaths?: string[]
  inactivePaths?: string[]
  matchSubpaths?: boolean
  setOpen: { (isOpen: boolean): void }
}

const Link = ({
  to,
  icon,
  name,
  level,
  badge,
  isOpen,
  isFolder,
  hasChild,
  requiresPremium,
  activePaths = [],
  inactivePaths = [],
  matchSubpaths = false,
  onClick,
  setOpen,
}: Props) => {
  const location = useLocation();
  const matchesPath = (path: string) => (
    location.pathname === path
    || (matchSubpaths && location.pathname.startsWith(`${path}/`))
  );

  const isInactive = inactivePaths.some(path => matchesPath(path));
  const isActive = !isInactive && activePaths.some(path => matchesPath(path));

  return (
    <S.StyledLink
      to={to}
      isopen={isOpen ? 1 : 0}
      onClick={onClick}
      className={isActive ? 'active' : ''}
      style={{
        paddingLeft: level > 1 ? (level * 28) - 14 : 14,
      }}
    >
      <ItemIcon
        icon={icon as any}
        level={level}
        isFolder={isFolder}
      />
      <S.Name>{name}</S.Name>
      {badge && <S.Badge>{badge}</S.Badge>}

      {requiresPremium && (
        <S.PremiumLock />
      )}

      {hasChild && (
        <S.Arrow
          isOpen={isOpen}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpen(!isOpen);
          }}
        />
      )}
    </S.StyledLink>
  );
};

export default Link;
